import { Caution } from "@icon-park/svg";
import { FC } from "react";
import Icon from "../Icon";
import { Locale } from "../lib/i18n";
import { offerLabels } from "../lib/labels";
import Popover from "../Popover";

interface ConditionallyFeasableBadgeProps {
  locale: Locale;
}
const ConditionallyFeasableBadge: FC<ConditionallyFeasableBadgeProps> = ({
  locale,
}) => {
  const labels = offerLabels[locale];
  return (
    <Popover
      variant="white"
      content={
        <>
          <h4 className="text-app-h3 mb-2xs">{labels.conditionalTitle}</h4>
          <p className="text-app-body-1">{labels.conditionalDescription}</p>
        </>
      }
      trigger="hover"
    >
      <span className="text-marigold-750 ml-2xs w-m h-m rounded-full bg-marigold-100 bg-opacity-50 flex justify-center items-center cursor-pointer">
        <Icon icon={Caution} size="20" className="" />
      </span>
    </Popover>
  );
};

export default ConditionallyFeasableBadge;
